<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label-width
                          prop="create_time"
                          label="统计日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker v-model="form.create_time"
                              type="monthrange"
                              style="width:100%"
                              value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="month"
                          label="月份">
              <number-range v-model="form.month"></number-range>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="统计日期"
                       width="100px"></el-table-column>
      <el-table-column prop="month"
                       align="center"
                       header-align="center"
                       label="月份"
                       width="60px"></el-table-column>

      <el-table-column prop="visitor"
                       align="center"
                       header-align="center"
                       label="访客数"></el-table-column>
      <el-table-column prop="wxdfks"
                       align="center"
                       header-align="center"
                       label="无线端访客数"></el-table-column>
      <el-table-column prop="pcdfks"
                       align="center"
                       header-align="center"
                       label="PC端访客数"></el-table-column>
      <el-table-column prop="liulanliang"
                       align="center"
                       header-align="center"
                       label="浏览量"></el-table-column>
      <el-table-column prop="wxdlll"
                       align="center"
                       header-align="center"
                       label="无线端浏览量"></el-table-column>
      <el-table-column prop="pcdlll"
                       align="center"
                       header-align="center"
                       label="PC端浏览量"></el-table-column>
      <el-table-column prop="spfks"
                       align="center"
                       header-align="center"
                       label="商品访客数"></el-table-column>
      <el-table-column prop="wxdspfks"
                       align="center"
                       header-align="center"
                       label="无线端商品访客数"></el-table-column>
      <el-table-column prop="pcdspfks"
                       align="center"
                       header-align="center"
                       label="PC端商品访客数"></el-table-column>
      <el-table-column prop="splll"
                       align="center"
                       header-align="center"
                       label="商品浏览量"></el-table-column>
      <el-table-column prop="wxdsplll"
                       align="center"
                       header-align="center"
                       label="无线端商品浏览量"></el-table-column>
      <el-table-column prop="pcdsplll"
                       align="center"
                       header-align="center"
                       label="PC端商品浏览量"></el-table-column>
      <el-table-column prop="pjtlsc"
                       align="center"
                       header-align="center"
                       label="平均停留时长"></el-table-column>
      <el-table-column prop="wxdpjtlsc"
                       align="center"
                       header-align="center"
                       label="无线端平均停留时长"></el-table-column>
      <el-table-column prop="pcdpjtlsc"
                       align="center"
                       header-align="center"
                       label="PC端平均停留时长"></el-table-column>
      <el-table-column prop="tslv"
                       align="center"
                       header-align="center"
                       label="跳失率"></el-table-column>
      <el-table-column prop="wxdtslv"
                       align="center"
                       header-align="center"
                       label="无线端跳失率"></el-table-column>
      <el-table-column prop="pcdtslv"
                       align="center"
                       header-align="center"
                       label="PC端跳失率"></el-table-column>
      <el-table-column prop="spscmjs"
                       align="center"
                       header-align="center"
                       label="商品收藏买家数"></el-table-column>
      <el-table-column prop="wxdspscmjs"
                       align="center"
                       header-align="center"
                       label="无线端商品收藏买家数"></el-table-column>
      <el-table-column prop="pcdspscmjs"
                       align="center"
                       header-align="center"
                       label="PC端商品收藏买家数"></el-table-column>
      <el-table-column prop="spsccs"
                       align="center"
                       header-align="center"
                       label="商品收藏次数"></el-table-column>
      <el-table-column prop="wxdspsccs"
                       align="center"
                       header-align="center"
                       label="无线端商品收藏次数"></el-table-column>
      <el-table-column prop="pcdspsccs"
                       align="center"
                       header-align="center"
                       label="PC端商品收藏次数"></el-table-column>
      <el-table-column prop="jgrs"
                       align="center"
                       header-align="center"
                       label="加购人数"></el-table-column>
      <el-table-column prop="wxdjgrs"
                       align="center"
                       header-align="center"
                       label="无线端加购人数"></el-table-column>
      <el-table-column prop="pcdjgrs"
                       align="center"
                       header-align="center"
                       label="PC端加购人数"></el-table-column>
      <el-table-column prop="zfje"
                       align="center"
                       header-align="center"
                       label="支付金额"></el-table-column>
      <el-table-column prop="pcdzfje"
                       align="center"
                       header-align="center"
                       label="PC端支付金额"></el-table-column>
      <el-table-column prop="wxdzfje"
                       align="center"
                       header-align="center"
                       label="无线端支付金额"></el-table-column>
      <el-table-column prop="pcdzfmjs"
                       align="center"
                       header-align="center"
                       label="PC端支付买家数"></el-table-column>
      <el-table-column prop="wxdzfmjs"
                       align="center"
                       header-align="center"
                       label="无线端支付买家数"></el-table-column>
      <el-table-column prop="zfzdds"
                       align="center"
                       header-align="center"
                       label="支付子订单数"></el-table-column>
      <el-table-column prop="pcdzfzdds"
                       align="center"
                       header-align="center"
                       label="PC端支付子订单数"></el-table-column>
      <el-table-column prop="wxdzfzdds"
                       align="center"
                       header-align="center"
                       label="无线端支付子订单数"></el-table-column>
      <el-table-column prop="zfjs"
                       align="center"
                       header-align="center"
                       label="支付件数"></el-table-column>
      <el-table-column prop="pcdzfjs"
                       align="center"
                       header-align="center"
                       label="PC端支付件数"></el-table-column>
      <el-table-column prop="wxdzfjs"
                       align="center"
                       header-align="center"
                       label="无线端支付件数"></el-table-column>
      <el-table-column prop="xdje"
                       align="center"
                       header-align="center"
                       label="下单金额"></el-table-column>
      <el-table-column prop="pcdxdje"
                       align="center"
                       header-align="center"
                       label="PC端下单金额"></el-table-column>
      <el-table-column prop="wxdxdje"
                       align="center"
                       header-align="center"
                       label="无线端下单金额"></el-table-column>
      <el-table-column prop="xdmjs"
                       align="center"
                       header-align="center"
                       label="下单买家数"></el-table-column>
      <el-table-column prop="pcdxdmjs"
                       align="center"
                       header-align="center"
                       label="PC端下单买家数"></el-table-column>
      <el-table-column prop="wxdxdmjs"
                       align="center"
                       header-align="center"
                       label="无线端下单买家数"></el-table-column>
      <el-table-column prop="xdjs"
                       align="center"
                       header-align="center"
                       label="下单件数"></el-table-column>
      <el-table-column prop="pcdxdjs"
                       align="center"
                       header-align="center"
                       label="PC端下单件数"></el-table-column>
      <el-table-column prop="wxdxdjs"
                       align="center"
                       header-align="center"
                       label="无线端下单件数"></el-table-column>
      <el-table-column prop="rjlll"
                       align="center"
                       header-align="center"
                       label="人均浏览量"></el-table-column>
      <el-table-column prop="pcdrslll"
                       align="center"
                       header-align="center"
                       label="PC端人均浏览量"></el-table-column>
      <el-table-column prop="wxdrjlll"
                       align="center"
                       header-align="center"
                       label="无线端人均浏览量"></el-table-column>
      <el-table-column prop="xdzhlv"
                       align="center"
                       header-align="center"
                       label="下单转化率"></el-table-column>
      <el-table-column prop="pcdxdzhlv"
                       align="center"
                       header-align="center"
                       label="PC端下单转化率"></el-table-column>
      <el-table-column prop="wxdxdzhlv"
                       align="center"
                       header-align="center"
                       label="无线端下单转化率"></el-table-column>
      <el-table-column prop="zfzhlv"
                       align="center"
                       header-align="center"
                       label="支付转化率"></el-table-column>
      <el-table-column prop="pcdzfzhlv"
                       align="center"
                       header-align="center"
                       label="PC端支付转化率"></el-table-column>
      <el-table-column prop="wxdzfzhlv"
                       align="center"
                       header-align="center"
                       label="无线端支付转化率"></el-table-column>
      <el-table-column prop="kdj"
                       align="center"
                       header-align="center"
                       label="客单价"></el-table-column>
      <el-table-column prop="pcdkdj"
                       align="center"
                       header-align="center"
                       label="PC端客单价"></el-table-column>
      <el-table-column prop="wxdkdj"
                       align="center"
                       header-align="center"
                       label="无线端客单价"></el-table-column>
      <el-table-column prop="uvjz"
                       align="center"
                       header-align="center"
                       label="UV价值"></el-table-column>
      <el-table-column prop="pcduvjz"
                       align="center"
                       header-align="center"
                       label="PC端UV价值"></el-table-column>
      <el-table-column prop="wxduvjz"
                       align="center"
                       header-align="center"
                       label="无线端UV价值"></el-table-column>
      <el-table-column prop="lfks"
                       align="center"
                       header-align="center"
                       label="老访客数"></el-table-column>
      <el-table-column prop="xfks"
                       align="center"
                       header-align="center"
                       label="新访客数"></el-table-column>
      <el-table-column prop="wxdxfks"
                       align="center"
                       header-align="center"
                       label="无线端老访客数"></el-table-column>
      <el-table-column prop="pcdlfks"
                       align="center"
                       header-align="center"
                       label="无线端新访客数"></el-table-column>
      <el-table-column prop="pcdxfks"
                       align="center"
                       header-align="center"
                       label="PC端老访客数"></el-table-column>
      <el-table-column prop="pcdxfks"
                       align="center"
                       header-align="center"
                       label="PC端新访客数"></el-table-column>
      <el-table-column prop="jgjs"
                       align="center"
                       header-align="center"
                       label="加购件数"></el-table-column>
      <el-table-column prop="pcdjgjs"
                       align="center"
                       header-align="center"
                       label="PC端加购件数"></el-table-column>
      <el-table-column prop="wxdjgjs"
                       align="center"
                       header-align="center"
                       label="无线端加购件数"></el-table-column>
      <el-table-column prop="zflmjs"
                       align="center"
                       header-align="center"
                       label="支付老买家数"></el-table-column>
      <el-table-column prop="pcdzflmjs"
                       align="center"
                       header-align="center"
                       label="PC端支付老买家数"></el-table-column>
      <el-table-column prop="wxdzflmjs"
                       align="center"
                       header-align="center"
                       label="无线端支付老买家数"></el-table-column>
      <el-table-column prop="lmjzfje"
                       align="center"
                       header-align="center"
                       label="老买家支付金额"></el-table-column>
      <el-table-column prop="ztcxs"
                       align="center"
                       header-align="center"
                       label="直通车消耗"></el-table-column>
      <el-table-column prop="zszwxh"
                       align="center"
                       header-align="center"
                       label="钻石展位消耗"></el-table-column>
      <el-table-column prop="tbkyj"
                       align="center"
                       header-align="center"
                       label="淘宝客佣金"></el-table-column>
      <el-table-column prop="cgtkje"
                       align="center"
                       header-align="center"
                       label="成功退款金额"></el-table-column>
      <el-table-column prop="zffdds"
                       align="center"
                       header-align="center"
                       label="支付父订单数"></el-table-column>
      <el-table-column prop="ffbgs"
                       align="center"
                       header-align="center"
                       label="发货包裹数"></el-table-column>
      <el-table-column prop="lsbgs"
                       align="center"
                       header-align="center"
                       label="揽收包裹数"></el-table-column>
      <el-table-column prop="zjzfqssc"
                       align="center"
                       header-align="center"
                       label="平均支付_签收时长(秒)"></el-table-column>
      <el-table-column prop="psbgs"
                       align="center"
                       header-align="center"
                       label="派送包裹数"></el-table-column>
      <el-table-column prop="qscgbgs"
                       align="center"
                       header-align="center"
                       label="签收成功包裹数"></el-table-column>
      <el-table-column prop="xdzfzhlv"
                       align="center"
                       header-align="center"
                       label="下单-支付转化率"></el-table-column>
      <el-table-column prop="pcdxdzfzhlv"
                       align="center"
                       header-align="center"
                       label="PC端下单-支付转化率"></el-table-column>
      <el-table-column prop="wxdxdzfzhlv"
                       align="center"
                       header-align="center"
                       label="无线端下单-支付转化率"></el-table-column>
      <el-table-column prop="zfsps"
                       align="center"
                       header-align="center"
                       label="支付商品数"></el-table-column>
      <el-table-column prop="pcdzfsps"
                       align="center"
                       header-align="center"
                       label="PC端支付商品数"></el-table-column>
      <el-table-column prop="wxdzfsps"
                       align="center"
                       header-align="center"
                       label="无线端支付商品数"></el-table-column>
      <el-table-column prop="dpscmjs"
                       align="center"
                       header-align="center"
                       label="店铺收藏买家数"></el-table-column>
      <el-table-column prop="pcddpscmjs"
                       align="center"
                       header-align="center"
                       label="PC端店铺收藏买家数"></el-table-column>
      <el-table-column prop="wxddpscmjs"
                       align="center"
                       header-align="center"
                       label="无线端店铺收藏买家数"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/canmou/shoptotalmonth/index.vue